import {observer} from "mobx-react";
import EditorPageLayout from "../../../../../../components/layouts/editor-page/editor-page-layout";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import {useCallback, useState} from "react";
import {ConfirmModal} from "../../../../../../components/modal/components/confirm-modal/confirm-modal";
import useNavigationBlocker from "../../../../../../hooks/navigation-blocker-hook";
import ListLayout from "../../../../../../components/layouts/list-layout/list-layout";
import {CHARGED_FEES_INVOICE_EMAIL} from "./constants";
import TranslationInput from "../../../../../../translation/translation-input/translation-input";
import ChargedFeesPreview from '../../../../../../images/previews/charge-fees-draft-order.svg';
import ControlGroupWithPreview
    from "../../../../../../components/layouts/control-group-with-preview/control-group-with-preview";
import {FormField} from "../../../../../../components/form-field/form-field";

const ChargedFeesInvoiceEditor: React.FC = observer(() => {

    const [isShowUnsaved, setIsShowUnsaved] = useState(false);

    const {
        hasChanges: hasTranslationChanges,
        discardChanges: translationsDiscardChanges,
        save: saveTranslations,
        getHint
    } = useTranslation();

    const hasChanges = () => {
        return hasTranslationChanges();
    }

    const {retryNavigation, unblockNavigation} = useNavigationBlocker(
        () => hasChanges(),
        useCallback(() => setIsShowUnsaved(true), [setIsShowUnsaved])
    );

    const discardChanges = () => {
        translationsDiscardChanges();
    }

    const onSaveClicked = () => {
        const promised = [];

        if (hasTranslationChanges()) {
            promised.push(
                saveTranslations()
            );
        }

        Promise.all(promised).then(() => {
            unblockNavigation();
        })
    }

    return <>
        <EditorPageLayout
            toolbar={{
                saveButton: {
                    hasChanges: hasChanges(),
                    disabled: !hasChanges(),
                    onClick: onSaveClicked
                }
            }}
        >
            <ListLayout>
                <ControlGroupWithPreview
                    preview={
                        <ListLayout>
                            <img src={ChargedFeesPreview} alt="" />
                        </ListLayout>
                    }
                    gridStyle={
                        {
                            childrenWidth: { width: 1.5 , type: 'fr' },
                            previewWidth: { width: 2, type: 'fr' }
                        }
                    }>
                    <ListLayout>
                        <FormField label={'Subject'} instructions={getHint(CHARGED_FEES_INVOICE_EMAIL.SUBJECT)}>
                            <TranslationInput translationKey={CHARGED_FEES_INVOICE_EMAIL.SUBJECT}/>
                        </FormField>

                        <FormField label={'Instructions'} instructions={getHint(CHARGED_FEES_INVOICE_EMAIL.CUSTOM_MESSAGE)}>
                            <TranslationInput translationKey={CHARGED_FEES_INVOICE_EMAIL.CUSTOM_MESSAGE}/>
                        </FormField>
                    </ListLayout>
                </ControlGroupWithPreview>
            </ListLayout>
        </EditorPageLayout>
        {isShowUnsaved &&
            <ConfirmModal
                cancelButton={{
                    title: 'Cancel',
                    onClick: () => setIsShowUnsaved(false)
                }}
                okButton={{
                    title: 'Discard',
                    onClick: () => {
                        discardChanges();
                        setIsShowUnsaved(false);
                        retryNavigation();
                    }
                }}
            />
        }
    </>
});

export default ChargedFeesInvoiceEditor;